<template>
	<div>
		<leftMenuUser
			:select="select"
		/>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import leftMenuUser from  "../../menu/leftMenuUser.vue";
		export default {
			name: 'teachers_part2',
			data(){
				return {

				}
			},
			components: {
				btn,
				leftMenuUser,
			},
			props: {
				select:{
					default: "0"
				},
			},
			mounted(){

			},
			methods:{

			}
		}
	</script>
<style>

</style>
